import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const tipos = [
  { key: 'departamento', label: 'Departamento', icon: '🏢' },
  { key: 'casa', label: 'Casa', icon: '🏡' },
  { key: 'local', label: 'Local', icon: '🏪' },
  { key: 'oficina', label: 'Oficina', icon: '🏛️' },
  { key: 'ph', label: 'PH', icon: '🌇' },
  { key: 'terreno', label: 'Terreno', icon: '🟫' },
];

const caracteristicas = [
  { key: 'cochera', label: 'Cochera', icon: '🚗' },
  { key: 'ascensor', label: 'Ascensor', icon: '🛗' },
  { key: 'pileta', label: 'Pileta', icon: '🏊' },
  { key: 'quincho', label: 'Quincho', icon: '🔥' },
  { key: 'seguridad', label: 'Seguridad 24h', icon: '🔐' },
  { key: 'amenities', label: 'Amenities', icon: '✨' },
];

export default function NuevaTasacion() {
  const navigate = useNavigate();
  const [tipo, setTipo] = useState('departamento');
  const [chars, setChars] = useState(['cochera']);

  const toggleChar = (k) => setChars(prev => prev.includes(k) ? prev.filter(c => c !== k) : [...prev, k]);

  return (
    <div className="app-shell">
      <div className="topbar">
        <div className="topbar-left">
          <span className="topbar-back" onClick={() => navigate('/dashboard')}>←</span>
          <div className="topbar-title">Nueva tasación</div>
        </div>
        <span className="topbar-action">✕</span>
      </div>

      <div className="page-body">
        <div className="field-label">Tipo de propiedad</div>
        <div className="type-grid">
          {tipos.map(t => (
            <div key={t.key} className={`type-btn${tipo === t.key ? ' active' : ''}`} onClick={() => setTipo(t.key)}>
              <span className="type-icon">{t.icon}</span>
              {t.label}
            </div>
          ))}
        </div>

        <div className="field-label">Ubicación</div>
        <div className="field-input active" style={{ justifyContent: 'space-between' }}>
          <span>Av. Rivadavia 4520, CABA</span>
          <span className="georef-tag">Georef ✓</span>
        </div>

        <div className="field-label">Superficie cubierta (m²)</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          <div className="field-input">
            <span>68 m² cubiertos</span>
            <span style={{ fontSize: 13, opacity: 0.4 }}>✏️</span>
          </div>
          <div className="field-input">
            <span>12 m² semi</span>
            <span style={{ fontSize: 13, opacity: 0.4 }}>✏️</span>
          </div>
        </div>

        <div className="field-label">Ambientes y baños</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          <div className="field-input">
            <span>🛏 2 ambientes</span>
            <span style={{ fontSize: 13, opacity: 0.4 }}>✏️</span>
          </div>
          <div className="field-input">
            <span>🚿 1 baño</span>
            <span style={{ fontSize: 13, opacity: 0.4 }}>✏️</span>
          </div>
        </div>

        <div className="field-label">Antigüedad</div>
        <div className="field-input">
          <span>15 años</span>
          <span style={{ fontSize: 13, opacity: 0.4 }}>✏️</span>
        </div>

        <div className="field-label">Características</div>
        <div className="chars-grid">
          {caracteristicas.map(c => (
            <div key={c.key} className={`char-chip${chars.includes(c.key) ? ' active' : ''}`} onClick={() => toggleChar(c.key)}>
              <span>{c.icon}</span>{c.label}
            </div>
          ))}
        </div>

        <div style={{ marginTop: 24 }}>
          <button className="btn-primary" onClick={() => navigate('/comparables/1')}>
            🔍 Buscar comparables
          </button>
        </div>
      </div>
    </div>
  );
}
